import { isPapertradeError } from "../sdk";
import type { Refusal } from "../sdk";

/** What a ticket refusal says, short enough for a button. */
export const REFUSAL: Record<Refusal, string> = {
  loading: "Loading markets",
  badAmount: "Enter a valid stake",
  noMargin: "Set a stake",
  noWallet: "Connect a wallet",
  noAccount: "Loading your bankroll",
  tradingPaused: "Play is paused",
  marketClosed: "Market is closed to new calls",
  intakePaused: "New calls are paused",
  belowMinimumMargin: "Stake below the minimum",
  belowMinimumNotional: "Raise stake or multiplier",
  aboveMaximumPosition: "Above the table limit",
  leverageTooHigh: "Multiplier above the max",
  insufficientFunds: "Not enough in your bankroll",
  queueLiquidity: "The payout queue can't fund this yet",
  openInterest: "This side is full",
};

/** One line for any failure, in the player's words. */
export function describe(error: unknown): string {
  if (!isPapertradeError(error)) return error instanceof Error ? error.message : String(error);
  switch (error.kind) {
    case "declined":
      return "Declined in your wallet";
    case "wrongChain":
      return "Your wallet is on another network";
    case "wrongWallet":
      return "The connected wallet is not this account's owner";
    case "needsKey":
      return "Turn on one-tap play first";
    case "refused":
      return (error.code && REFUSAL[error.code as Refusal]) || error.message;
    case "rateLimited":
      return "Too many requests, try again in a moment";
    case "relayer":
      return error.reason || error.code || error.message;
    case "notKept":
      return `The relayer did not keep it (${error.state ?? "unknown"})`;
    case "network":
      return "Network error: the relayer did not answer. Check your open calls before retrying.";
    case "noAccount":
      return "Your bankroll has not loaded yet";
    default:
      return error.message;
  }
}

/** Whether a failure was the player saying no: shown quietly, if at all. */
export const declined = (error: unknown) => isPapertradeError(error) && error.kind === "declined";
